"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Import = _interopRequireDefault(require("@rsuite/icon-font/lib/network/Import"));

// Generated by script, don't edit it please.
var Import = (0, _createSvgIcon["default"])({
  as: _Import["default"],
  ariaLabel: 'import',
  category: 'network',
  displayName: 'Import'
});
var _default = Import;
exports["default"] = _default;
module.exports = exports.default;